import type { ItemTotal } from '../types';
import PanelCloseButton from './PanelCloseButton';

type Props = {
  itemTotals: ItemTotal[];
  showClose: boolean;
  onClose: () => void;
};

/** The "Item totals" block — used standalone as the Expo aux panel and embedded in the station one. */
const ItemTotalsPanel = ({ itemTotals, showClose, onClose }: Props) => {
  if (itemTotals.length === 0) return null;
  return (
    <div className="flex-none flex flex-col min-h-0 max-h-[45%] border-b border-grey-medium">
      <div className="flex items-center justify-between gap-2 pl-4 pr-2 pt-3 pb-2">
        <h3 className="m-0 text-standard font-bold">Total to make</h3>
        {showClose && <PanelCloseButton onClose={onClose} />}
      </div>
      <div className="overflow-y-auto px-4 pb-3 flex flex-col gap-1">
        {itemTotals.map((total) => (
          <div key={total.name} className="flex gap-2 items-baseline text-small">
            <span className="font-bold text-brand-secondary flex-none min-w-5">{total.quantity}×</span>
            <span className="text-brand-black truncate">{total.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ItemTotalsPanel;
